module.exports = __webpack_public_path__ + "static/img/fruit.33a645be.png";